import React, { PureComponent } from 'react';
import { ScenarioSimulation, ScenarioSimulationStatus } from '../../ApplicableScenariosPanel';
import { Spin } from 'antd';
import { DetailedSolution, ReroutedFlightDto } from '../../../../../model/SOL49';
import { MeasureImpactPanel } from '../../../solver/MeasureImpactPanel';
import { Flex } from 'app/components/common/Flex';
import { WarningOutlined } from '@ant-design/icons';

interface SimulationResultDetailsProps {
    solverSolutions: Array<DetailedSolution>;
    simulationState: ScenarioSimulation;
    onShowTVsImpact: () => void;
    onShowMeasuresImpact: () => void;
    onShowOnMap: () => void;
    onRrtFlightShowOnMap: (flights: ReroutedFlightDto[]) => void;
}

export default class SimulationResultDetails extends PureComponent<SimulationResultDetailsProps> {
    /**
     * RENDERING
     */
    render() {
        switch (this.props.simulationState.simulationStatus) {
            case ScenarioSimulationStatus.SUCCESS:
                return this.renderSolutionDetails(
                    this.props.solverSolutions[this.props.simulationState.simulationSolutionIdx],
                );
            case ScenarioSimulationStatus.FAILED:
                return this.renderError(
                    'Simulation failed due: ' + this.props.simulationState.simulationError?.message ??
                        'Unexpected error',
                );
            case ScenarioSimulationStatus.IN_PROGRESS:
                return this.renderLoading();
        }
    }

    private renderSolutionDetails(solutionDetails: DetailedSolution) {
        return (
            <MeasureImpactPanel
                solution={solutionDetails}
                simplifiedDisplay
                meteoAlerts={null}
                solutionImpactOutdated={false}
                onRemoveMeasure={measure => {}}
                onMeasureEdited={(measureId, measure) => {}}
                onShowTVsImpact={this.props.onShowTVsImpact}
                onShowMeasuresImpact={this.props.onShowMeasuresImpact}
                onUpdateSolution={() => {}}
                onApplySolution={() => {}}
                onApplicableScenarios={() => {}}
                onShareSolution={() => {}}
                onShowOnMap={this.props.onShowOnMap}
                onRrtFlightShowOnMap={this.props.onRrtFlightShowOnMap}
            />
        );
    }

    renderLoading() {
        return (
            <Flex direction="vertical" style={{ justifyContent: 'center', alignContent: 'center' }}>
                <Spin size={'large'} />
                <Flex grow={false} style={{ justifyContent: 'center', marginTop: '10px' }} direction={'horizontal'}>
                    <Flex grow={false}>Simulation in Progress...</Flex>
                </Flex>
            </Flex>
        );
    }

    renderError(message: string = 'Unexpected Error Happened') {
        return (
            <Flex direction="vertical" style={{ justifyContent: 'center', alignContent: 'center' }}>
                <WarningOutlined style={{ fontSize: '8em' }} />
                <Flex grow={false} style={{ justifyContent: 'center', marginTop: '10px' }} direction={'horizontal'}>
                    <Flex grow={false}>{message}</Flex>
                </Flex>
            </Flex>
        );
    }
}
